// From the pure schema entry of platform: this file is bundled into the web app through ./schema.
import { definePermissions } from '@mkcore/platform/schema';

/**
 * Permissions of the agent platform (D30). Creating, changing and stopping agents also needs tenant-wide scope in the
 * service: an agent identity gets roles, so only someone who oversees the whole company may make one.
 */
export const agentPermissions = definePermissions('agents', {
  read: 'View agents, their role, instructions and status',
  create: 'Register an agent: its identity and profile',
  update: 'Change an agent, pause it or resume it',
  manage: 'Terminate an agent for good',
  chat: 'Chat with an agent in the web app: your own lasting chat per agent, and mention agents (CO-0857)',
  work: 'Run sessions of Claude Code and CLI agents as a worker: register, heartbeat, fetch work and report (CO-1256)',
});
